export default __webpack_public_path__ + "static/media/host_hold_active.af324d39.svg";